import {CardBrand} from "@app/core/payment-method/application/card-brand";

interface StoredCardDTOParams {
    readonly id: string;
    readonly brand: CardBrand;
    readonly expiryMonth: string;
    readonly expiryYear: string;
    readonly lastFourDigits: string;
}

/**
 * Represents a payment card added by the user.
 */
export class StoredCardDTO {
    readonly id: string;
    readonly brand: CardBrand;
    readonly expiryMonth: string;
    readonly expiryYear: string;
    readonly lastFourDigits: string;
    
    constructor(params: StoredCardDTOParams) {
        this.id = params.id;
        this.brand = params.brand;
        this.expiryMonth = params.expiryMonth;
        this.expiryYear = params.expiryYear;
        this.lastFourDigits = params.lastFourDigits;
    }
}